'use strict';

var appDom = require('./app-dom');

var init = function() {

	var $video = appDom.promo.find('.promo__video');
	var $iframe;
	var width;
	var height;

	if ($video.length) {

		$iframe = $video.find('iframe');
		width = parseInt($iframe.attr('width'), 10);
		height = parseInt($iframe.attr('height'), 10);

		if (width && height) {

			$video.css('padding-bottom', (height / width * 100) + '%');

		} else {

			// This may be a "responsive" vimeo video that has it's own container
			$video.css('height', 'auto');

		}

	}

};

module.exports = {
	init: init
};
